export const strokeWidths = {
  strokeWidthThin: '1px',
  strokeWidthThick: '2px',
  strokeWidthThicker: '3px',
  strokeWidthThickest: '4px'
};
//# sourceMappingURL=strokeWidths.js.map